import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledCalendarContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledCalendarContainer", componentId: "auir-611444a-1dzfs1c" }) `
  display: flex;
  justify-content: center;
  padding: var(${(props) => props.theme.responsive.spacing.m});

  overflow-y: auto;
`;
//# sourceMappingURL=DatePicker.styles.mjs.mjs.map